import { render, staticRenderFns } from "./AllocationProducts.vue?vue&type=template&id=55e3abd3&scoped=true"
import script from "./AllocationProducts.vue?vue&type=script&lang=js"
export * from "./AllocationProducts.vue?vue&type=script&lang=js"
import style0 from "./AllocationProducts.vue?vue&type=style&index=0&id=55e3abd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e3abd3",
  null
  
)

export default component.exports